import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiResponse } from '../../../../common/models/api-response.model';
import { Insight } from '../../../../common/models/insight.model';
import { CreatedRequest } from '../../../../common/models/created-by-me.model';

export type CreatedTasksSort = { key: string; value: 'asc' | 'desc' };

export interface CreatedTasksUiFeatures {
  showResourceTypeFilter: boolean;
  showProjectLink: boolean;
}

export interface CreatedTasksAdapter {
  readonly uiFeatures: CreatedTasksUiFeatures;

  getTasks(
    page: number,
    perPage: number,
    filter: string,
    sort: CreatedTasksSort,
    search: string,
    additionalFilters?: Record<string, string | string[]>
  ): Observable<ApiResponse<CreatedRequest>>;

  getArchiveTasks(
    page: number,
    perPage: number,
    sort: CreatedTasksSort,
    search: string,
    additionalFilters?: Record<string, string | string[]>
  ): Observable<ApiResponse<CreatedRequest>>;

  getInsights(): Observable<{ data: Insight[] }>;

  exportTasks(form: Record<string, unknown>): Observable<unknown>;

  archiveRequest(workflowId: number): Observable<unknown>;

  restoreRequest(workflowId: number): Observable<unknown>;

  getRequestViewLink(flowId: number): string;

  getRelatedRequestViewLink(childFlowId: number): string;
}

export const CREATED_TASKS_ADAPTER = new InjectionToken<CreatedTasksAdapter>(
  'CREATED_TASKS_ADAPTER'
);
